import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { ChartWrapper } from 'src/components';
import PropTypes from 'prop-types';


const getBorderColor = year => {
  switch (year) {
    case 2021:
      return 'rgba(244, 67, 54, 0.8)';
    case 2022:
      return 'rgba(255, 152, 0, 0.8)';
    case 2023:
      return 'rgba(76, 175, 80, 0.9)';
    case 2024:
      return 'rgba(33, 150, 243, 1)';
    default:
      return 'rgba(158, 158, 158, 0.7)';
  }
};

const NatureVariation = ({ natureVariation }) => {
  const data = {
    labels: natureVariation.labels,
    datasets: [
      ...natureVariation.datasets.map(ds => ({
        label: ds.year.toString(),
        data: ds.data,
        borderColor: getBorderColor(ds.year),
        pointBackgroundColor: getBorderColor(ds.year),
        fill: false,
      })),
    ],
  };
  const options = {
    scales: {
      r: {
        beginAtZero: true,
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10,
          callback: value => `${value}%`,
          backdropColor: 'transparent',
          font: { size: 10 },
        },
        pointLabels: {
          font: {
            size: 12,
          },
          color: context => {
            const disabledLabels = natureVariation.disabledLabels || [];
            return disabledLabels.includes(context.index) ? '#9e9e9e' : '#333';
          },
        },
        angleLines: { display: true },
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: { size: 10 },
        },
      },
      tooltip: { enabled: true },
    },
    maintainAspectRatio: false,
  };

  return (
    <>
      <Typography variant="caption" color="textSecondary" gutterBottom>
          Condición de cada indicador en el proyecto
      </Typography>
      <Box mt={2} height="380px" p={1}>
        <ChartWrapper type="radar" data={data} options={options} />
      </Box>
    </>
  );
};

NatureVariation.propTypes = {
  natureVariation: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    positiveImpactZone: PropTypes.number.isRequired,
    disabledLabels: PropTypes.arrayOf(PropTypes.number),
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        year: PropTypes.number.isRequired,
        data: PropTypes.arrayOf(PropTypes.number).isRequired,
      }),
    ).isRequired,
  }).isRequired,
};


export {
  NatureVariation,
};
